import React from 'react';

/** "Client Only" / "Group: X". Renders nothing when the client is in no group. */
export default function ViewModeToggle({ mode, groupName, onChange,
                                         clientLabel = 'Client Only' }) {
  if (!groupName) return null;

  const btn = (active) => ({
    padding: '6px 18px',
    border: 'none',
    background: active ? '#3b82f6' : 'transparent',
    color: active ? 'white' : '#6b7280',
    borderRadius: 6,
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.2s',
  });

  return (
    <div style={{
      background: '#f3f4f6', borderRadius: 8, padding: 4, display: 'inline-flex',
      boxShadow: 'inset 0 0 2px rgba(0,0,0,0.05)', width: 'fit-content',
    }}>
      <button type="button" style={btn(mode === 'client')} onClick={() => onChange('client')}>
        {clientLabel}
      </button>
      <button type="button" style={btn(mode === 'group')} onClick={() => onChange('group')}>
        Group: {groupName}
      </button>
    </div>
  );
}
